export const isClient = () => {
    return typeof window !== 'undefined';
};
